<div
  fxLayout="row"
  fxLayoutAlign="start stretch"
  style="height: 99%; width: 100%"
>
  <as-split direction="horizontal">
    <as-split-area>
      <div fxFlex="auto">
        <ng-container *ngIf="data">
          <app-table
            #tableComponent
            [source]="data"
            (btnTable)="clickBtnHeat($event)"
          ></app-table>
        </ng-container>
      </div>
    </as-split-area>
    <as-split-area *ngIf="selectedAlt">
      <div fxFlex="auto">
        <div class="h-2/5">
          <ng-container *ngIf="data_D">
            <app-table #tableComponent_D [source]="data_D"></app-table>
          </ng-container>
        </div>
      </div>
    </as-split-area>
  </as-split>
  <input
    type="file"
    name=""
    id="hiddenInput"
    hidden
    (change)="fileSelected($event)"
  />
</div>
<div
  *ngIf="selectedAlt"
  class="fixed right-10 bottom-0 bg-white rounded-t-lg shadow-lg border border-gray-600 transition"
  style="width: 400px; box-shadow: 0px 0px 20px #0000001f"
  [style]="chatOpened ? 'height: 500px;' : 'height:50px'"
>
  <div
    class="relative flex justify-between p-8 border-gray-400"
    [style]="chatOpened ? 'height: 8%' : 'height:100%'"
    [class]="chatOpened ? 'border-b' : 'cursor-pointer'"
  >
    <span class="text-xl font-bold text-blue-800 ml-10">{{ selectedAlt }}</span>
    <mat-icon class="cursor-pointer" (click)="chatOpened = !chatOpened">{{
      chatOpened ? "close" : "keyboard_arrow_up"
    }}</mat-icon>
  </div>
  <div
    [style]="chatOpened ? 'height: 80%;' : 'display:none;'"
    class="overflow-scroll"
    id="scrollDiv"
  >
    <ng-container *ngFor="let message of messages">
      <span
        [id]="'Date' + message.Date_Create"
        class="text-gray-800 text-center flex justify-center w-full dontShowDate"
      >
        {{ message.Date_Create | date: "dd-MM-yyyy" }}
      </span>
      <div
        class="w-full flex flex-col"
        [class]="
          message.User_Id_Create == generalService.user.userName
            ? 'items-end'
            : 'items-start'
        "
      >
        <div
          (click)="showDate('Date' + message.Date_Create)"
          *ngIf="
            message.User_Id_Create == generalService.user.userName &&
            message.FilesNote_Text != ''
          "
          class="message bg-blue-800 text-white float-right"
          [class]="
            message.FilesStatic_Id
              ? 'rounded-3xl rounded-br-none'
              : 'rounded-3xl'
          "
        >
          {{ message.FilesNote_Text }}
        </div>

        <div
          (click)="showDate('Date' + message.Date_Create)"
          *ngIf="
            message.User_Id_Create != generalService.user.userName &&
            message.FilesNote_Text != ''
          "
          class="message bg-gray-300 text-gray-800 float-left"
          [class]="
            message.FilesStatic_Id
              ? 'rounded-3xl rounded-bl-none'
              : 'rounded-3xl'
          "
        >
          {{ message.FilesNote_Text }}
        </div>
        <img
          (click)="browseImages = message.FilesStatic_Id"
          [class]="
            message.FilesNote_Text != ''
              ? message.User_Id_Create == generalService.user.userName
                ? 'rounded-3xl rounded-tr-none float-right bg-blue-800'
                : 'rounded-3xl rounded-tl-none float-left bg-gray-300'
              : message.User_Id_Create == generalService.user.userName
              ? 'rounded-3xl float-right bg-blue-800'
              : 'rounded-3xl float-left bg-gray-300'
          "
          style="width: 30%; padding: 0.3rem !important"
          *ngIf="message.isImage && message.FilesStatic_Id"
          [src]="message.FilesStatic_Id"
          class="message p-1 mt-0"
        />
        <div
          *ngIf="!message.isImage && message.FilesStatic_Id"
          [class]="
            message.FilesNote_Text != ''
              ? message.User_Id_Create == generalService.user.userName
                ? 'rounded-3xl rounded-tr-none float-right bg-blue-800 text-white'
                : 'rounded-3xl rounded-tl-none float-left bg-gray-300 text-gray-700'
              : message.User_Id_Create == generalService.user.userName
              ? 'rounded-3xl float-right bg-blue-800 text-white'
              : 'rounded-3xl float-left bg-gray-300 text-gray-700'
          "
          style="padding: 0.5rem 1rem !important"
          class="p-1 m-4 mt-0 flex items-center"
        >
          <mat-icon class="cursor-pointer">file_download</mat-icon>
          <!-- <a
        [href]="message.FilesStatic_Id"
        class="hover:underline cursor-pointer"
        [download]="message.FilesStatic_Name"
        target="_blank"
        rel="noopener noreferrer"
        >{{ message.FilesStatic_Name }}</a
      > -->
          <span
            class="hover:underline cursor-pointer"
            (click)="download(message.FilesStatic_Id, message.FilesStatic_Name)"
            >{{ message.FilesStatic_Name }}</span
          >
        </div>
      </div>
    </ng-container>
  </div>
  <div
    class="relative flex justify-between px-8 py-3 border-t border-gray-400 items-center"
    [style]="chatOpened ? 'height: 12%;' : 'display:none;'"
  >
    <mat-icon
      class="cursor-pointer text-blue-800"
      (click)="clickHiddenUpload()"
      [matBadge]="addedFile ? '1' : ''"
      >attach_file</mat-icon
    >
    <input
      type="text"
      class="rounded-xl bg-gray-200 w-10/12 h-full py-2 px-10 text-lg outline-none"
      placeholder="Aa"
      [(ngModel)]="textVal"
      (keydown.enter)="saveComment($event)"
    />
    <mat-icon class="cursor-pointer text-blue-600" (click)="saveComment($event)"
      >send</mat-icon
    >
  </div>
</div>
<ng-container *ngIf="browseImages">
  <div
    (click)="browseImages = null"
    class="fixed w-full h-full left-0 top-0 bg-opacity-90 bg-black"
  ></div>
  <div
    class="fixed w-full h-full left-0 top-0 z-50 text-center pointer-events-none"
    style="padding: 10rem"
  >
    <div class="bg-white inline-flex p-16">
      <img [src]="browseImages" style="width: 600px" />
    </div>
  </div>
</ng-container>
